import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { doveTornareOf, apriSchedaDellaCoda } from '@/lib/limulo/tornaAllaCoda';
import type { PresentazioneDiCoda } from '@/lib/limulo/presentazione';
import { giochiConCodeDaRiprendere, sitngoDiQtournamentsAcceso } from '@/lib/limulo/sitngoAcceso';
import { limuloApi } from '@/services/limuloApi';
import { useAppDispatch, useAppSelector } from '@/store/hooks';

/**
 * «Torna alla coda» / «Torna ai sit&go» (r15): porta alla scheda della Hub dove si aspetta, per il gioco del torneo.
 * ⚠️ Il catalogo giochi (`GET /v1/games`) si legge QUI, al tocco, dalla voce di cache che l'app ha gia' (nessuna lettura
 * al disegno: la modale d'esito non deve aggiungere una GET a ogni esito). Catalogo non arrivato ⇒ Clash Royale, com'e'
 * sempre stato per «Vai» della barra della coda (`BarraCoda`).
 */
export function useTornaAllaCoda(): (presentazione: PresentazioneDiCoda, gameId: string | null) => Promise<void> {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const giocoAttivoId = useAppSelector((s) => s.core.activeGames?.[0] ?? null);
  return useCallback(
    async (presentazione, gameId) => {
      const giochi = await dispatch(limuloApi.endpoints.getLimuloGames.initiate(undefined, { subscribe: false }))
        .unwrap()
        .catch(() => undefined);
      const profileType =
        gameId === null || !Array.isArray(giochi) ? null : (giochi.find((g) => g.gameId === gameId)?.profileType ?? null);
      apriSchedaDellaCoda(
        dispatch,
        doveTornareOf({
          presentazione,
          profileType,
          sitngoCrAcceso: sitngoDiQtournamentsAcceso(),
          conScheda: giochiConCodeDaRiprendere(),
        }),
        giocoAttivoId,
      );
      navigate('/');
    },
    [dispatch, navigate, giocoAttivoId],
  );
}
